/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Administration {

    @Serenity.Decorators.registerClass()
    export class JoinTenantDialog extends NoboxEntityDialog<TenantRow, any> {
        protected getFormKey() { return JoinTenantForm.formKey; }
        protected getIdProperty() { return TenantRow.idProperty; }
        protected getLocalTextPrefix() { return TenantRow.localTextPrefix; }
        protected getNameProperty() { return TenantRow.nameProperty; }
        protected getService() { return TenantService.baseUrl; }

        protected form = new JoinTenantForm(this.idPrefix);
        
        getToolbarButtons() {
            return [];
        }
        updateTitle() {
            this.dialogTitle = "Join Tenant";
        }
        getDialogButtons() {
            var buttons = [] as Serenity.DialogButton[];
            buttons.push({
                text: "Cancel",
                cssClass: "bg-secondary text-white",
                click: () => {
                    this.dialogClose();
                }
            })
            buttons.push({
                text: "Join Tenant",
                cssClass: "bg-primary",
                click: () => {
                    if (this.validateForm()) {
                        NoTenantService.JoinTenant({
                            Entity: {
                                InvCdGen: this.form.InvitatioCode.value
                            }
                        }, (res) => {
                            if (res.EntityId == "10") {
                                Q.notifySuccess("Success Join Tenant");
                                window.location.href = "/";
                            }
                        })
                    }
                }
            })
            return buttons;
        }
    }
}